import React, { useState, useEffect } from "react";
import { Card, Form, Spinner, Button } from "react-bootstrap";
import Cookies from "js-cookie";
import { useNavigate } from "react-router";
import axiosInstance from "../HSAxios";
import axios from "axios";
export default function Profile() {
  // const demo = {
  //   name: "Avinash",
  //   phone_number: "7042525862",
  //   balance: "20",
  // };
  const [loading, setLoading] = useState(true);
  const [owner, setOwner] = useState({});
  const [btnLoading, setBtnLoading] = useState(false);
  const [subStatus, setSubStatus] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const token = Cookies.get("token");

    if (token) {
      axiosInstance
        .get("api/hostel/owner")
        .then((response) => {
          if (response.status) {
            // do some work
            setOwner(response.data[0] || {});
            setSubStatus(response.subscription_status);
            setLoading(false);
          } else {
            setLoading(false);
          }
          // console.log(owner);
        })
        .catch((err) => {
          console.log(err);
          setLoading(false);
        });
    } else {
      setLoading(false);
    }
  }, []);
  console.log(owner);
  const handleCheckout = () => {
    navigate("/payment", { state: owner || {} });
  };

  return (
    <div>
      {loading && (
        <div className="d-flex flex-column align-items-center justify-content-center" style={{ minHeight: "70vh" }}>
          <Spinner
            animation="border"
            role="status"
            style={{
              width: "3rem",
              height: "3rem",
              borderWidth: "4px",
              borderColor: "#8B0000",
              borderRightColor: "transparent",
            }}
          />
          <p className="mt-4 fw-semibold" style={{ color: "#333", fontSize: "18px" }}>
            Loading your profile...
          </p>
        </div>
      )}

      {!loading && (
        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "70vh" }}>
          <Card
            className={`border-0 shadow-lg ${
              subStatus ? "border-success" : "border-warning"
            }`}
            style={{
              width: "100%",
              maxWidth: "450px",
              borderRadius: "20px",
              border: subStatus ? "3px solid #28a745" : "3px solid #ffc107",
              boxShadow: "0 10px 40px rgba(0,0,0,0.1)",
              transition: "transform 0.3s ease, box-shadow 0.3s ease",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-5px)";
              e.currentTarget.style.boxShadow = "0 15px 50px rgba(0,0,0,0.15)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow = "0 10px 40px rgba(0,0,0,0.1)";
            }}
          >
            <Card.Body className="p-4">
              <div className="text-center">
                <div
                  className={`mt-1 mb-3 p-2 rounded ${
                    subStatus ? "bg-success" : "bg-warning"
                  } fw-bold d-flex align-items-center justify-content-between`}
                  style={{
                    fontSize: "0.85rem",
                    color: "white",
                    borderRadius: "10px",
                  }}
                >
                  <span>
                    {subStatus
                      ? `Subscribed till ${owner?.contact_viewed_plan?.slice(
                          0,
                          11
                        ) || "N/A"}`
                      : `Subscription ended on ${owner?.contact_viewed_plan?.slice(
                          0,
                          11
                        ) || "N/A"}`}
                  </span>
                  <span style={{ width: "24px", height: "24px" }}>
                    {subStatus ? (
                      <img
                        src="confirmTick.png"
                        style={{
                          width: "100%",
                          height: "auto",
                          objectFit: "cover",
                        }}
                        alt="Active"
                      />
                    ) : (
                      <img
                        src="warningTick.png"
                        style={{
                          width: "100%",
                          height: "auto",
                          objectFit: "cover",
                        }}
                        alt="Expired"
                      />
                    )}
                  </span>
                </div>

                <div
                  style={{
                    height: "120px",
                    width: "120px",
                    margin: "20px auto",
                    borderWidth: "4px",
                  }}
                  className={`border p-2 ${
                    subStatus ? "border-success" : "border-warning"
                  } rounded-circle`}
                >
                  <img
                    className="rounded-circle"
                    src={`${process.env.PUBLIC_URL}/rb_4707.png`}
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                    alt="Profile"
                  />
                </div>
              </div>
              <Form>
                <Form.Group className="mt-3 text-start">
                  <Form.Label className="fw-semibold mb-2" style={{ color: "#333" }}>
                    Name
                  </Form.Label>
                  <Form.Control
                    type="text"
                    value={owner?.name || ""}
                    className="py-2"
                    style={{
                      borderRadius: "10px",
                      border: "2px solid #e0e0e0",
                    }}
                    disabled
                  />
                </Form.Group>

                <Form.Group className="mt-3 text-start">
                  <Form.Label className="fw-semibold mb-2" style={{ color: "#333" }}>
                    Phone Number
                  </Form.Label>
                  <Form.Control
                    type="text"
                    disabled
                    value={owner?.phone_number || ""}
                    className="py-2"
                    style={{
                      borderRadius: "10px",
                      border: "2px solid #e0e0e0",
                      backgroundColor: "#f8f9fa",
                    }}
                  />
                </Form.Group>
                <Form.Group className="mt-3 text-start">
                  <Form.Label className="fw-semibold mb-2" style={{ color: "#333" }}>
                    Current Wallet Balance
                  </Form.Label>
                  <Form.Control
                    type="text"
                    disabled
                    value={`₹${owner?.wallet_amount || "0"}`}
                    className="py-2 fw-bold"
                    style={{
                      borderRadius: "10px",
                      border: "2px solid #e0e0e0",
                      backgroundColor: "#f8f9fa",
                      fontSize: "18px",
                      color: "#28a745",
                    }}
                  />
                </Form.Group>
                <Form.Group className="mt-4">
                  <Button
                    style={{
                      backgroundColor: "#004AAD",
                      borderColor: "#004AAD",
                      width: "100%",
                      borderRadius: "10px",
                      padding: "12px",
                      fontSize: "16px",
                      fontWeight: "600",
                      transition: "all 0.3s ease",
                      boxShadow: "0 4px 15px rgba(0, 74, 173, 0.3)",
                    }}
                    className="fw-semibold"
                    type="button"
                    onClick={handleCheckout}
                    onMouseEnter={(e) => {
                      e.target.style.backgroundColor = "#0056b3";
                      e.target.style.transform = "translateY(-2px)";
                      e.target.style.boxShadow = "0 6px 20px rgba(0, 74, 173, 0.4)";
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.backgroundColor = "#004AAD";
                      e.target.style.transform = "translateY(0)";
                      e.target.style.boxShadow = "0 4px 15px rgba(0, 74, 173, 0.3)";
                    }}
                  >
                    Add More Money
                  </Button>
                </Form.Group>
              </Form>
            </Card.Body>
          </Card>
        </div>
      )}
    </div>
  );
}
